import { motion, AnimatePresence } from "framer-motion";

/** Easter egg: 5 clicks on the cauldron triggers a screen-wide purple overflow. */
export function SecretOverflow({ active }: { active: boolean }) {
  return (
    <AnimatePresence>
      {active && (
        <motion.div
          initial={{ y: "-100%" }}
          animate={{ y: "0%" }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.6, ease: [0.4, 0, 0.2, 1] }}
          className="fixed inset-0 z-[9999] pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at top, #c084fc 0%, #9b3df5 30%, #2a0050 70%, #06000d 100%)",
          }}
        >
          <motion.div
            className="absolute inset-x-0 top-0 h-1/2"
            style={{
              background:
                "linear-gradient(180deg, transparent, rgba(192,132,252,0.4), transparent)",
            }}
            animate={{ opacity: [0.3, 0.9, 0.3] }}
            transition={{ duration: 0.8, repeat: 3 }}
          />
          <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1.0, duration: 0.4 }}
            className="absolute inset-0 grid place-items-center"
          >
            <div className="text-center">
              <div className="font-display text-3xl md:text-5xl text-bone drop-shadow-[0_0_20px_rgba(0,0,0,0.6)]">
                THE CAULDRON OVERFLOWS
              </div>
              <div className="mt-3 font-terminal text-lg text-aura animate-pulse">
                ▒▒▒ secret unlocked ▒▒▒
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
